import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-385dc31b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "header-top"
}
const _hoisted_2 = { class: "header-top-left" }

import useHomeStore from '@/store/modules/home'
import { storeToRefs } from 'pinia'
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import LoginRegister from './login-register.vue'
import SubjectStage from './subject-stage.vue'


export default {
  __name: 'header-top',
  setup(__props) {

const router = useRouter()

const homeStore = useHomeStore()
const { showScrollHeader, defaultTab } = storeToRefs(homeStore)


const goHome = () => {
  defaultTab.value = 0
  router.push('/home')
}

return (_ctx, _cache) => {
  return (!_unref(showScrollHeader))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", { onClick: goHome }, "教师资源库"),
          _createVNode(SubjectStage)
        ]),
        _createVNode(LoginRegister)
      ]))
    : _createCommentVNode("", true)
}
}

}